/**
 * Description component
 * @returns <Description />
 */

import IconDescription from "./IconDescription"

const Description = ({ type, title, items }) => {
    if (type === "list") {
        return (
            <div className="description">
                <h4 className="description__title">{title}</h4>

                <ul>
                    {items.map((item, i) => {
                        return <li className="fw-300" key={i}>{item}</li>
                    })}
                </ul>
            </div>
        )
    } else if (type === "car") {
        return (
            <div className="description --car">
                {items.map((item, i) => {
                    return (
                        <div className="description__box" key={i}>
                            <IconDescription type={item.icon}></IconDescription>
                            <p>{item.smallText}</p>
                        </div>
                    )
                })}
            </div>
        )
    } else if (type === "html") {
        return (
            <div className="description">
                <h4 className="description__title">{title}</h4>

                <div dangerouslySetInnerHTML={{ __html: items }}></div>
            </div>
        )
    } else {
        return (
            <div className="description">
                <h4 className="description__title">{title}</h4>

                {items.map((item, i) => {
                    return <p className="fw-300" key={i}>{item}</p>
                })}
            </div>
        )
    }
}

export default Description